import styled from "styled-components";
import { Device, Color } from "@styles/constants";
import { AbsoluteCoverCSS } from "@styles/layout";

export const Container = styled.div`
  .swiper-slide {
    max-height: 70vh;
    background: #232324;
  }
`;

export const Controls = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 36px;

  @media ${Device.largeUp} {
    margin-top: 60px;
  }

  .cell {
    display: flex;
    align-items: center;
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid ${Color.grayBrand};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto 1px;
    }

    svg {
      fill: ${Color.blackBrand};
      width: 9px;
      height: 9px;
      transform-origin: center;
    }
  }

  .swiper-button-prev svg {
    margin-left: 3px;
  }

  .swiper-button-next svg {
    transform: scaleX(-1);
    margin-right: 3px;
  }

  .swiper-pagination {
    position: relative;
    bottom: 0;
    width: 42.75px;
    margin: 0 10px;
  }
`;

export const Slider = styled.div``;

export const Slide = styled.div`
  position: relative;
  padding-bottom: 100%;
  height: 0;

  @media ${Device.mediumUp} {
    padding-bottom: 0;
    height: 60vh;
  }

  @media ${Device.largeUp} {
    margin-left: 130px;
  }
`;

export const SlideWrap = styled.div<{ cover?: boolean }>`
  ${AbsoluteCoverCSS}

  button {
    z-index: 1;
  }

  img,
  video {
    display: block;
    height: 100%;
    width: 100%;
    margin: 0 auto;

    @media ${Device.mediumUp} {
      width: auto;
    }
  }

  img {
    width: 100%;
    object-fit: ${({ cover }) => (cover ? "cover" : "contain")};
  }
`;
